module.exports = __webpack_public_path__ + "img/2019-02-22.3b159582.jpg";